<template>
    <div class="container">
        <h3>Map Background Generator</h3>
        <div class="mb-3">
            <label for="title_english" class="form-label">{{ $t("admin.toolbox.map_background_generator.top_left_corner_latitude") }}</label>
            <input type="text" class="form-control" id="title_english" v-model="topLeftCornerLatitude">
        </div>
        <div class="mb-3">
            <label for="title_english" class="form-label">{{ $t("admin.toolbox.map_background_generator.top_left_corner_longitude") }}</label>
            <input type="text" class="form-control" id="title_english" v-model="topLeftCornerLatitude">
        </div>
        <div class="mb-3">
            <label for="title_english" class="form-label">{{ $t("admin.toolbox.map_background_generator.bottom_right_corner_latitude") }}</label>
            <input type="text" class="form-control" id="title_english" v-model="topLeftCornerLatitude">
        </div>
        <div class="mb-3">
            <label for="title_english" class="form-label">{{ $t("admin.toolbox.map_background_generator.bottom_right_corner_longitude") }}</label>
            <input type="text" class="form-control" id="title_english" v-model="topLeftCornerLatitude">
        </div>
        <div>
            <button class="btn btn-primary">{{ $t("admin.toolbox.map_background_generator.generate_button") }}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "MapBackgroundGeneratorTool",

    data() {
        return {
            topLeftCornerLatitude: null,
            topLeftCornerLongitude: null,
            bottomRightCornerLatitude: null,
            bottomRightCornerLongitude: null
        }
    }
}
</script>

<style scoped>

</style>